export default "__VITE_ASSET__D_haVI_y__"